import { cn } from './cn.js';

import type { ReactElement } from 'react';

interface SkeletonLoaderProps {
  variant?: 'block' | 'text' | 'circle';
  width?: string;
  height?: string;
  className?: string;
}

const variantClasses = {
  block: 'rounded-lg',
  text: 'rounded h-4',
  circle: 'rounded-full',
} as const;

export function SkeletonLoader({
  variant = 'block',
  width,
  height,
  className,
}: SkeletonLoaderProps): ReactElement {
  return (
    <div className={cn('skeleton', variantClasses[variant], className)} style={{ width, height }} />
  );
}
